import { useStore } from '@/store/useStore';

/** Tamper-evident audit trail display (PSD §8.2 / TODO Task 3.13). */
export function AuditTrail(): JSX.Element {
  const auditEntries = useStore((s) => s.auditEntries);

  if (auditEntries.length === 0) {
    return (
      <section className="panel panel-result" aria-label="Audit trail" data-testid="audit-trail">
        <h2 className="panel-title">Audit Trail</h2>
        <div className="empty-state">No actions logged yet. Changes you make will appear here.</div>
      </section>
    );
  }

  return (
    <section className="panel panel-result" aria-label="Audit trail" data-testid="audit-trail">
      <h2 className="panel-title">Audit Trail ({auditEntries.length})</h2>
      <div className="table-scroll">
        <table className="data-table">
          <thead>
            <tr>
              <th>Timestamp</th>
              <th>Event</th>
              <th>Field</th>
              <th>Hash (first 8)</th>
            </tr>
          </thead>
          <tbody>
            {auditEntries.map((entry) => (
              <tr key={entry.id}>
                <td>{new Date(entry.timestampISO).toLocaleString()}</td>
                <td>{entry.eventType}</td>
                <td>{entry.fieldChanged ?? '—'}</td>
                <td><code>{entry.hash.slice(0, 8)}</code></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="hint-text">
        Each entry is cryptographically chained (SHA-256). Tampering with any entry
        invalidates all subsequent hashes.
      </div>
    </section>
  );
}
